import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import TagsTable from "./TagsTable";
import "./DwvComponent.css";
import dwv from "dwv";
import cloudUploadIcon from "../assets/images/Icon feather-upload-cloud.svg";
// import { ValidationContext } from "graphql";
// gui overrides

// get element
dwv.gui.getElement = dwv.gui.base.getElement;

// Image decoders (for web workers)
dwv.image.decoderScripts = {
  jpeg2000: "assets/dwv/decoders/pdfjs/decode-jpeg2000.js",
  "jpeg-lossless": "assets/dwv/decoders/rii-mango/decode-jpegloss.js",
  "jpeg-baseline": "assets/dwv/decoders/pdfjs/decode-jpegbaseline.js",
  rle: "assets/dwv/decoders/dwv/decode-rle.js",
};

const styles = (theme) => ({
  button: {
    margin: "8px 4px",
  },
  appBar: {
    position: "relative",
  },
  title: {
    flex: "0 0 auto",
  },
  tagsDialog: {
    minHeight: "90vh",
    maxHeight: "90vh",
    minWidth: "90vw",
    maxWidth: "90vw",
  },
  iconSmall: {
    fontSize: 20,
  },
});

class DwvComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      versions: {
        dwv: dwv.getVersion(),
        react: React.version,
      },
      tools: {
        Scroll: {},
        ZoomAndPan: {},
        WindowLevel: {},
        Draw: {
          options: ["Ruler"],
          type: "factory",
          events: ["draw-create", "draw-change", "draw-move", "draw-delete"],
        },
      },
      selectedTool: "Select Tool",
      loadProgress: 0,
      dataLoaded: false,
      dwvApp: null,
      metaData: [],
      showDicomTags: false,
      toolMenuAnchorEl: null,
      dropboxClassName: "dropBox",
      borderClassName: "dropBoxBorder",
      hoverClassName: "hover",
      viewBox: true,
      imageView: true,
      errors: {},
      errorMessages: {},
    };
  }
  ValidationChecks = () => {
    let { errorMessages, errors } = this.state;
    let noErrors = true;
    if (this.props.Validation !== undefined) {
      const toValidate = Object.keys(this.props.Validation);
      toValidate.map((item) => {
        errors[item] = !this.props.Validation[item](
          this.props.dependentField[item]
        ).valid;
        if (errors[item]) {
          errorMessages[item] = this.props.Validation[item](
            this.props.dependentField[item]
          ).errMsg;

          return (noErrors = false);
        } else {
          return delete errorMessages[item];
        }
      });
    }
    this.setState({ errors, errorMessages });
    return noErrors;
  };
  render() {
    const { classes } = this.props;
    const { tools, dataLoaded, metaData } = this.state;

    Object.keys(tools).map((tool) => (
      <MenuItem
        onClick={this.handleMenuItemClick.bind(this, tool)}
        key={tool}
        value={tool}
      >
        {tool}
      </MenuItem>
    ));

    return (
      <div id="dwv">
        {/* <LinearProgress variant="determinate" value={loadProgress} /> */}
        <div className="button-row">
          {/* <Button
            variant="contained"
            color="primary"
            aria-owns={toolMenuAnchorEl ? "simple-menu" : null}
            aria-haspopup="true"
            onClick={this.handleMenuButtonClick}
            disabled={!dataLoaded}
            className={classes.button}
            size="medium"
          >
            {this.state.selectedTool}
            <ArrowDropDownIcon className={classes.iconSmall} />
          </Button> */}
          {/* <Menu
            id="simple-menu"
            anchorEl={toolMenuAnchorEl}
            open={Boolean(toolMenuAnchorEl)}
            onClose={this.handleMenuClose}
          >
            {toolsMenuItems}
          </Menu> */}

          {dataLoaded ? (
            <div>
              {" "}
              <Button
                variant="contained"
                color="primary"
                disabled={!dataLoaded}
                onClick={this.onReset}
                className={classes.button}
              >
                Reset
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleTagsDialogOpen}
                disabled={!dataLoaded}
                className={classes.button}
                size="medium"
              >
                Tags
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleRemoveFile}
                disabled={!dataLoaded}
                className={classes.button}
                size="medium"
              >
                Remove
              </Button>
            </div>
          ) : (
            ""
          )}
          <Dialog
            open={this.state.showDicomTags}
            onClose={this.handleTagsDialogClose}
            classes={{ paper: classes.tagsDialog }}
            className="tagsDialog"
          >
            <AppBar className={classes.appBar}>
              <Toolbar>
                <Typography
                  variant="h6"
                  // color="primary"
                  className={classes.flex}
                >
                  DICOM Tags
                </Typography>
                <IconButton
                  onClick={this.handleTagsDialogClose}
                  aria-label="Close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <TagsTable data={metaData} />
          </Dialog>
        </div>

        <div className="layerContainer" style={{ height: "auto" }}>
          <div className="dropBox dropBoxBorder" style={{ width: "a" }}>
            {/* <Typography>Drag and drop data here.</Typography> */}
            {this.state.imageView ? (
              <img src={cloudUploadIcon} alt="cloud" />
            ) : (
              ""
            )}
            <p>{this.props.textname}</p>
            <p>or</p>
            <input
              id="myFile"
              type="file"
              style={{ display: "none" }}
              onChange={(e) => this.onButtonClick(e)}
              onClick={(e) => (e.target.value = null)}
            />
            <Button onClick={this.browseFile}>Browse File</Button>
          </div>
          <canvas className="imageLayer"></canvas>
          {/* <div className="drawDiv"></div> */}
        </div>
      </div>
    );
  }

  componentDidMount() {
    // create app
    var app = new dwv.App();
    // initialise app
    app.init({
      containerDivId: "dwv",
      tools: this.state.tools,
    });

    // load events
    let nReceivedError = null;
    let nReceivedAbort = null;
    app.addEventListener("load-start", (/*event*/) => {
      nReceivedError = 0;
      nReceivedAbort = 0;
    });
    app.addEventListener("load-progress", (event) => {
      this.setState({ loadProgress: event.loaded });
    });
    app.addEventListener("load", (/*event*/) => {
      // set dicom tags
      let filteredArray = Object.values(
        dwv.utils.objectToArray(app.getMetaData())
      );
      filteredArray = filteredArray.filter((items) =>
        Number.isInteger(items.vl)
      );
      this.setState({ metaData: filteredArray });
      // set the selected tool
      let selectedTool = "Scroll";
      if (app.isMonoSliceData() && app.getImage().getNumberOfFrames() === 1) {
        selectedTool = "ZoomAndPan";
      }
      this.onChangeTool(selectedTool);
      // hide dropBox
      this.hideDropbox();
      // set data loaded flag
      this.setState({ dataLoaded: true });
    });
    app.addEventListener("load-end", (/*event*/) => {
      if (nReceivedError) {
        this.setState({ loadProgress: 0 });
        this.props.fileData("", "This file is not supported.");
        // alert("Received errors during load. Check log for details.");
        const box = this.state.dwvApp.getElement("hideBox");
        const viewBox = this.state.dwvApp.getElement("imageLayer");
        //   this.setState({viewBox:true})
        let files = document.getElementById("myFile").files;

        if (viewBox) {
          viewBox.setAttribute("style", `display:none`);
        }
        if (files) {
        }
        if (box) {
          // box.setAttribute(
          //   'style',
          //   'width:' + dropBoxSize + 'px;height:' + dropBoxSize + 'px'
          // );
          box.setAttribute(
            "class",
            this.state.dropboxClassName + " " + this.state.borderClassName
          );
          // box.setAttribute("class", this.state.borderClassName);
          this.setState({ dataLoaded: false });
        }
      }
      if (nReceivedAbort) {
        this.setState({ loadProgress: 0 });
        alert("Load was aborted.");
      }
    });
    app.addEventListener("error", (event) => {
      console.error(event.error);
      ++nReceivedError;
    });
    app.addEventListener("abort", (/*event*/) => {
      ++nReceivedAbort;
    });

    // handle key events
    app.addEventListener("keydown", (event) => {
      app.defaultOnKeydown(event);
    });
    // handle window resize
    window.addEventListener("resize", app.onResize);

    // store
    this.setState({ dwvApp: app });

    // setup drop box
    this.setupDropbox(app);

    // possible load from location
    dwv.utils.loadFromUri(window.location.href, app);
  }

  /**
   * Handle a change tool event.
   * @param tool The new tool name.
   */
  onChangeTool = (tool) => {
    if (this.state.dwvApp) {
      this.setState({ selectedTool: tool });
      this.state.dwvApp.setTool(tool);
      if (tool === "Draw") {
        this.onChangeShape(this.state.tools.Draw.options[0]);
      }
    }
  };

  /**
   * Handle a change draw shape event.
   * @param shape The new shape name.
   */
  onChangeShape = (shape) => {
    if (this.state.dwvApp) {
      this.state.dwvApp.setDrawShape(shape);
    }
  };

  /**
   * Handle a reset event.
   */
  onReset = (tool) => {
    if (this.state.dwvApp) {
      this.state.dwvApp.resetDisplay();
    }
  };

  /**
   * Open the DICOM tags dialog.
   */
  handleTagsDialogOpen = () => {
    this.setState({ showDicomTags: true });
  };

  /**
   * Close the DICOM tags dialog.
   */
  handleTagsDialogClose = () => {
    this.setState({ showDicomTags: false });
  };

  /**
   * Menu button click.
   */
  handleMenuButtonClick = (event) => {
    this.setState({ toolMenuAnchorEl: event.currentTarget });
  };

  /**
   * Menu cloase.
   */
  handleMenuClose = (event) => {
    this.setState({ toolMenuAnchorEl: null });
  };

  /**
   * Menu item click.
   */
  handleMenuItemClick = (tool) => {
    this.setState({ toolMenuAnchorEl: null });
    this.onChangeTool(tool);
  };

  // drag and drop [begin] -----------------------------------------------------

  /**
   * Setup the data load drop box: add event listeners and set initial size.
   */
  setupDropbox = (app) => {
    // start listening to drag events on the layer container
    const layerContainer = app.getElement("layerContainer");
    if (layerContainer) {
      layerContainer.addEventListener("dragover", this.onDragOver);
      layerContainer.addEventListener("dragleave", this.onDragLeave);
      layerContainer.addEventListener("drop", this.onDrop);
    }
    // set the initial drop box size
    const box = app.getElement(this.state.dropboxClassName);
    if (box) {
      // app.getLayerContainerSize();
      //   const size = app.getLayerContainerSize();
      // const dropBoxSize = (2 * size.height) / 3;
      // box.setAttribute(
      //   "style",
      //   "width:" + dropBoxSize + "px;height:" + dropBoxSize + "px"
      // );
    }
  };

  /**
   * Handle a drag over.
   * @param event The event to handle.
   */
  onDragOver = (event) => {
    console.log("Enter");
    // addClass('is-dragover');
    // prevent default handling
    event.stopPropagation();
    event.preventDefault();
    // update box border
    const box = this.state.dwvApp.getElement(this.state.borderClassName);
    if (box && box.className.indexOf(this.state.hoverClassName) === -1) {
      box.className += " " + this.state.hoverClassName;
    }
    console.log(box,"-----BOX-----");
    
  };
  browseFile = (event) => {
    if (this.ValidationChecks())
    document.getElementById("myFile").click();
    else this.props.fileData("");
  };
  checkFileType = (file) => {
    var file = file[0];
    if (file.type.includes("video") || file.type.includes("image"))
      return false;
    else return true;
  };
  onButtonClick = (event) => {
    event.preventDefault();
    let files = document.getElementById("myFile").files;
    if (this.checkFileType(files)) {
      try {
        this.state.dwvApp.loadFiles(files);
        this.props.fileData(files);
        // hide drop box

        this.hideDropbox();
      } catch (e) {
        this.props.fileData("", "This file is not supported.");
      }
    } else {
      this.props.fileData("", "This file is not supported.");
    }
  };
  /**
   * Handle remove file
   *
   */
  handleRemoveFile = (event) => {
    // var app = new dwv.App();
    const box = this.state.dwvApp.getElement("hideBox");
    const viewBox = this.state.dwvApp.getElement("imageLayer");
    //   this.setState({viewBox:true})
    let files = document.getElementById("myFile").files;

    if (viewBox) {
      viewBox.setAttribute("style", `display:none`);
    }
    if (files) {
    }
    if (box) {
      // box.setAttribute(
      //   'style',
      //   'width:' + dropBoxSize + 'px;height:' + dropBoxSize + 'px'
      // );
      box.setAttribute(
        "class",
        this.state.dropboxClassName + " " + this.state.borderClassName
      );
      this.props.fileData("");
      // box.setAttribute("class", this.state.borderClassName);
      this.setState({ dataLoaded: false });
    }
    // this.state.dwvApp
  };
  /**
   * Handle a drag leave.
   * @param event The event to handle.
   */
  onDragLeave = (event) => {
    // prevent default handling
    event.stopPropagation();
    event.preventDefault();
    // update box class
    const box = this.state.dwvApp.getElement(this.state.borderClassName + " hover"); 
    if (box && box.className.indexOf(this.state.hoverClassName) !== -1) {
      box.className = box.className.replace(
        " " + this.state.hoverClassName,
        ""
      );
    }
  };

  /**
   * Hide the data load drop box.
   */
  hideDropbox = () => {
    // remove box
    const box = this.state.dwvApp.getElement(this.state.dropboxClassName);
    const viewBox = this.state.dwvApp.getElement("imageLayer");
    if (viewBox) {
      viewBox.setAttribute("style", `display:initial`);
    }
    if (box) {
      // box.parentNode.removeChild(box);
      box.removeAttribute("style");
      // remove border
      box.className = box.className.replace(
        "" + this.state.borderClassName,
        ""
      );
      box.className = box.className.replace("" + this.state.hoverClassName, "");
      box.setAttribute("class", "hideBox");
    }
    // this.setState({viewBox:false})
  };

  /**
   * Handle a drop event.
   * @param event The event to handle.
   */
  onDrop = (event) => {
    // prevent default handling
    event.stopPropagation();
    event.preventDefault();
    // load files
    if(this.ValidationChecks())
    if (this.checkFileType(event.dataTransfer.files)) {
      try {
        this.state.dwvApp.loadFiles(event.dataTransfer.files);
        this.props.fileData(event.dataTransfer.files);
        this.hideDropbox();
      } catch (e) {
        console.log(e, "err");
        this.props.fileData("", "This file is not supported.");
      }
      // hide drop box
    } else this.props.fileData("", "This file is not supported.");
    else this.props.fileData("");
  };

  // drag and drop [end] -------------------------------------------------------
} // DwvComponent

DwvComponent.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DwvComponent);
